import React from "react";

const railImages = [
  "amex_blue_cash_everyday_card.png",
  "bofa_bankamericard.png",
  "capitalone_generic.png",
  "chase_freedom_flex.png",
  "citi_diamond.png",
  "discover.png",
  "amex_blue_cash.png",
  "bofa_secured.png",
  "capitalone_platinum.png",
  "chase_freedom_unlimited.png",
  "citi_simplicity.png",
  "wells_fargo.png",
  "amex_generic.png",
  "chase_sapphire_preferred.png",
  "citi_generic.png"
];

function Loading() {
  // duplicate for seamless infinite scroll
  const loop = railImages.concat(railImages);

  return (
    <div className="panel center fadeIn">
      <h2 className="loadingTitle">
        Finding the <span className="accent">PERFECT</span> credit cards for you!
      </h2>

      <div className="cardRail">
        <div className="cardRailInner">
          {loop.map((img, i) => (
            <div className="railCardWrap" key={img + i}>
              <img
                src={"/cards/" + img}
                alt=""
                className="railCard"
                draggable="false"
                onError={(e) => {
                  e.currentTarget.src = "/cards/citi_generic.png";
                }}
              />
            </div>
          ))}
        </div>
      </div>

      <p className="subtle loadingSub">
        Analyzing rewards, approval odds, and value…
      </p>

      <div className="loadingFooter">
        <span>
          Created by <strong>Martin Donev</strong>
        </span>
        <span className="dot">•</span>
        <a
          href="https://github.com/Marty207"
          target="_blank"
          rel="noopener noreferrer"
        >
          GitHub: Marty207
        </a>
      </div>
    </div>
  );
}

export default Loading;
